import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Popover,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Checkbox,
  Typography,
  Autocomplete,
  CircularProgress,
  MenuItem,
  Menu,
  Grid,
  Divider,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Delete as DeleteIcon,
  Edit,
  Print,
  Visibility,
  Description as FileIcon,
  ExpandMore,
  ExpandLess,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useState, useEffect, useRef } from "react";
import { ToastContainer } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Chip } from "@mui/material";
import {
  ProformaInvoiceListApi,
  ProformaInvoiceDelete,
  ApproveProformaInvoice,
  DivisionList,
  ProformaInvoiceExportExcel,
} from "../../../Services/Services";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import { printPerforma } from "../Sale/performaPrint";
pdfMake.vfs = pdfFonts.vfs;

const ProformaInvoiceTable = () => {
  const [filters, setFilters] = useState({
    division: "",
    pi_no: "",
    project_name: "",

    date_range: "today",
  });
  // Existing states ke neeche ye add karo
  const [excelLoading, setExcelLoading] = useState(false);
  const [proformas, setProformas] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [invoiceToDelete, setInvoiceToDelete] = useState(null);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();
  const [divisionLists, setDivisionLists] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [piToApprove, setPIToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const [showRemarkForOrderId, setShowRemarkForOrderId] = useState(null);
  const dateRangeBoxRef = useRef(null);
  const [customDateRange, setCustomDateRange] = useState({
    from: "",
    to: "",
  });

  // ⭐ ADD THESE TWO NEW STATES
  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [selectingDate, setSelectingDate] = useState(null); // ✅ 'from' or 'to' or null
  const dateInputRef = useRef(null);

  const userRole = localStorage.getItem("role");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedInvoice, setExpandedInvoice] = useState(null);
const [loading, setLoading] = useState(false);

  // ✅ Handle filter logic
  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchProformas(1, filters, true);
    }, 500);

    return () => clearTimeout(handler);
  }, [filters, customDateRange]);
  useEffect(() => {
    const fetchData = async () => {
      const divisions = await DivisionList();
      setDivisionLists(divisions || []);
    };
    fetchData();
  }, []);

  // ✅ Helper function to format date from YYYY-MM-DD to DD-MM-YYYY
  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  // ✅ Helper function to convert DD-MM-YYYY back to YYYY-MM-DD (for backend)
  const formatDateForBackend = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  };
  const fetchProformas = async (pageNum = 1, filterObj = filters, reset = false) => {
  // 👇 Show loader only on first page/reset
  if (pageNum === 1 || reset) {
    setLoading(true);
  }

  try {
    const params = { ...filterObj };

    if (filterObj.date_range === "custom" && customDateRange.from && customDateRange.to) {
      params.from_date = customDateRange.from;
      params.to_date = customDateRange.to;
    }

    const res = await ProformaInvoiceListApi(pageNum, params);

    if (reset || pageNum === 1) {
      setProformas(res.results);
    } else {
      setProformas((prev) => [...prev, ...res.results]);
    }

    setHasMore(res.next !== null);
    setPage(pageNum);
  } catch (error) {
    console.error("Error fetching proformas:", error);
    toast.error("Failed to fetch data");
  } finally {
    setLoading(false); // 👈 Hide loader
  }
};

  const fetchMoreData = () => {
    if (!hasMore) return;
    const nextPage = page + 1;
    fetchProformas(nextPage, filters);
  };

  const handleExcelExport = async () => {
    setExcelLoading(true);
    try {
      const blob = await ProformaInvoiceExportExcel(filters, customDateRange);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Proforma_Invoice_${new Date().getTime()}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      toast.success("Excel downloaded successfully!");
    } catch (error) {
      console.error("Excel export error:", error);
      toast.error("Failed to export Excel");
    } finally {
      setExcelLoading(false);
    }
  };

  const handleApprove = async (invoice, status) => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    const piId = invoice?.invoice_number || invoice?.invoice?.invoice_number;
    if (!piId) {
      toast.error("PI ID is undefined.");
      return;
    }

    try {
      const updated = await ApproveProformaInvoice(
        piId,
        approvedById,
        invoice.status,
        remarkInput,
      );

      const updatedList = await ProformaInvoiceListApi();
      setProformas(updatedList.results);

      toast.success(
        updated.status === "Approved"
          ? "PI approved successfully!"
          : "PI unapproved successfully!",
      );
    } catch (error) {
      console.error("Approval Toggle Error:", error);
      toast.error("Failed to toggle PI approval.");
    }
  };
  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);

      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);

      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1); // Monday
        return `${formatDate(weekStart)} to ${formatDate(now)}`;

      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay()); // Last Sunday
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6); // Last Monday
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;

      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;

      case "current_year":
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;

      case "financial_year":
        let fyStart;
        if (now.getMonth() >= 3) {
          // April to December
          fyStart = new Date(now.getFullYear(), 3, 1); // April 1
        } else {
          // January to March
          fyStart = new Date(now.getFullYear() - 1, 3, 1); // Last year April 1
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;

      default:
        return "";
    }
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleReset = () => {
    setFilters({
      division: "",
      pi_no: "",
      project_name: "",
      date_range: "today", // ✅ Fixed
    });
    setCustomDateRange({ from: "", to: "" });
    setTempCustomDateRange({ from: "", to: "" }); // ⭐ ADD THIS LINE
    setShowCustomDateInputs(false); // ⭐ ADD THIS LINE
    setSelectingDate(null);
    setProformas([]);
    setPage(1);
    setHasMore(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedInvoice(null);
  };

  const handleDelete = async (invoiceNumber) => {
    if (!invoiceNumber) {
      toast.error("Invalid invoice number.");
      return;
    }

    const res = await ProformaInvoiceDelete(invoiceNumber);

    if (res && res.message !== "Not found") {
      toast.success("Invoice deleted successfully.");
      const data = await ProformaInvoiceListApi();
      setProformas(data.results);
    } else {
      toast.error("Failed to delete invoice.");
    }
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  function formatOnlyDate(dateTimeString) {
    if (!dateTimeString) return "N/A";

    // Take only the date part (before T)
    const datePart = dateTimeString.split("T")[0]; // "2025-12-02"

    const [year, month, day] = datePart.split("-");

    return `${day}-${month}-${year}`;
  }

  useEffect(() => {
    document.body.style.overflow = "hidden"; // disable window scroll

    return () => {
      document.body.style.overflow = "auto"; // cleanup: scroll wapas enable
    };
  }, []);

  // ⭐ ADD THESE TWO FUNCTIONS AFTER formatDateForBackend

  // ✅ Apply Custom Date Range
  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({ ...tempCustomDateRange });
      setFilters((prev) => ({ ...prev, date_range: "custom" }));
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  // ✅ Cancel Custom Date Range
  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };
  return (
    <>
    <Box sx={{ position: "relative", minHeight: "80vh" }}>
      
      {/* 🔄 LOADING OVERLAY */}
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            zIndex: 1000,
            borderRadius: 1,
          }}
        >
          <CircularProgress size={50} thickness={4} color="primary" />
          <Typography sx={{ mt: 2, color: "#333", fontWeight: 500 }}>
            {filters.date_range === "financial_year"
              ? "Loading Financial Year Data..."
              : filters.date_range === "current_year"
              ? "Loading Current Year Data..."
              : "Loading Data..."}
          </Typography>
          <Typography sx={{ mt: 0.5, color: "#666", fontSize: "0.8rem" }}>
            Please wait, this may take a moment
          </Typography>
        </Box>
      )}
      {/* Filters */}
      <Box sx={{ mt: -3, pt: -3, mb: 2, width: "100%" }}>
        <ToastContainer position="top-right" autoClose={3000} />

        <Grid container spacing={2} alignItems="center">
          {/* ✅ Date Range */}
          <Grid item xs={12} sm={2.5}>
            <TextField
              label="Date Range"
              value={
                filters.date_range === "custom" &&
                customDateRange.from &&
                customDateRange.to
                  ? `${formatDateDisplay(customDateRange.from)} to ${formatDateDisplay(customDateRange.to)}`
                  : filters.date_range === "today"
                    ? "Today"
                    : filters.date_range === "yesterday"
                      ? "Yesterday"
                      : filters.date_range === "this_week"
                        ? "This Week"
                        : filters.date_range === "previous_week"
                          ? "Previous Week"
                          : filters.date_range === "this_month"
                            ? "This Month"
                            : filters.date_range === "current_year"
                              ? "Current Year"
                              : filters.date_range === "financial_year"
                                ? "Financial Year"
                                : "Select Date Range"
              }
              onClick={(e) => setDateMenuAnchor(e.currentTarget)}
              size="small"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              sx={{
                cursor: "pointer",
                "& .MuiInputBase-root": {
                  height: 35,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
              fullWidth
            />
          </Grid>

          {/* ⭐ REPLACE OLD MENU WITH THIS */}
          <Menu
            anchorEl={dateMenuAnchor}
            open={Boolean(dateMenuAnchor)}
            onClose={() => {
              setDateMenuAnchor(null);
              setShowCustomDateInputs(false);
              setTempCustomDateRange({ from: "", to: "" });
            }}
            PaperProps={{
              sx: { width: 350, maxHeight: 500 },
            }}
          >
            {/* Quick Ranges */}
            {[
              { key: "today", label: "Today" },
              { key: "yesterday", label: "Yesterday" },
              { key: "this_week", label: "This Week" },
              { key: "previous_week", label: "Previous Week" },
              { key: "this_month", label: "This Month" },
              { key: "current_year", label: "Current Year" },
              { key: "financial_year", label: "Financial Year" },
            ].map((item) => (
              <MenuItem
                key={item.key}
                onClick={() => {
                  setFilters((prev) => ({ ...prev, date_range: item.key }));
                  setCustomDateRange({ from: "", to: "" });
                  setDateMenuAnchor(null);
                  setShowCustomDateInputs(false);
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography variant="body2">{item.label}</Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontSize: "0.7rem" }}
                  >
                    {getDateRangeDisplay(item.key)}
                  </Typography>
                </Box>
              </MenuItem>
            ))}

            <Divider />

            {/* ✅ Custom Date Range - Expandable */}
            <MenuItem
              onClick={() => setShowCustomDateInputs((prev) => !prev)}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
              >
                Custom Date Range
              </Typography>
              {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
            </MenuItem>

            <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
              <Box
                sx={{
                  px: 2,
                  py: 2,
                  bgcolor: "#f5f5f5",
                  borderTop: "1px solid #e0e0e0",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ mb: 1, display: "block" }}
                >
                  Select Date Range
                </Typography>

                {/* From and To Date Inputs Side by Side */}
                <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                  <TextField
                    label="From Date"
                    type="date"
                    size="small"
                    value={tempCustomDateRange.from}
                    onChange={(e) =>
                      setTempCustomDateRange((prev) => ({
                        ...prev,
                        from: e.target.value,
                      }))
                    }
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      max: tempCustomDateRange.to || undefined,
                    }}
                    sx={{
                      flex: 1,
                      "& .MuiInputBase-root": {
                        height: 40,
                        fontSize: "0.75rem",
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: "0.75rem",
                      },
                    }}
                  />

                  <TextField
                    label="To Date"
                    type="date"
                    size="small"
                    value={tempCustomDateRange.to}
                    onChange={(e) =>
                      setTempCustomDateRange((prev) => ({
                        ...prev,
                        to: e.target.value,
                      }))
                    }
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      min: tempCustomDateRange.from || undefined,
                    }}
                    sx={{
                      flex: 1,
                      "& .MuiInputBase-root": {
                        height: 40,
                        fontSize: "0.75rem",
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: "0.75rem",
                      },
                    }}
                  />
                </Box>

                {/* Selected Range Preview */}
                {tempCustomDateRange.from && tempCustomDateRange.to && (
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      mb: 1.5,
                      p: 1,
                      bgcolor: "#e8f5e9",
                      borderRadius: 1,
                      textAlign: "center",
                      color: "#2e7d32",
                      fontWeight: 500,
                    }}
                  >
                    📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                    {formatDateDisplay(tempCustomDateRange.to)}
                  </Typography>
                )}

                {/* Apply and Cancel Buttons */}
                <Box
                  sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}
                >
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleCancelCustomDateRange}
                    sx={{
                      fontSize: "0.7rem",
                      textTransform: "none",
                      borderRadius: 1,
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleApplyCustomDateRange}
                    disabled={
                      !tempCustomDateRange.from || !tempCustomDateRange.to
                    }
                    sx={{
                      fontSize: "0.7rem",
                      textTransform: "none",
                      borderRadius: 1,
                    }}
                  >
                    Apply
                  </Button>
                </Box>
              </Box>
            </Collapse>
          </Menu>

          {/* ✅ Division Filter */}
          {/* <Grid item xs={12} sm={2.5}>
            <Autocomplete
              options={divisionLists || []}
              getOptionLabel={(opt) => opt?.division || ""}
              isOptionEqualToValue={(opt, val) =>
                opt.division_id === val?.division_id || opt.division_id === val
              }
              value={
                divisionLists.find(
                  (opt) => opt.division_id === filters.division,
                ) || null
              }
              onChange={(e, newValue) =>
                setFilters((prev) => ({
                  ...prev,
                  division: newValue ? newValue.division_id : "",
                }))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Filter by Division"
                  variant="outlined"
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": { height: 35, borderRadius: 0 },
                    "& .MuiInputLabel-root": { fontSize: "0.7rem" },
                  }}
                />
              )}
            />
          </Grid> */}

          {/* ✅ PI No Filter */}
          <Grid item xs={12} sm={2.5}>
            <TextField
              label="Search by PI No."
              name="pi_no"
              value={filters.pi_no}
              onChange={handleFilterChange}
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: 35,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.65rem",
                },
              }}
              fullWidth
            />
          </Grid>

          {/* ✅ Project Name Filter */}
          <Grid item xs={12} sm={2.5}>
            <TextField
              label="Search by Project Name"
              name="project_name"
              value={filters.project_name}
              onChange={handleFilterChange}
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: 35,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.65rem",
                },
              }}
              fullWidth
            />
          </Grid>

          {/* ✅ Reset Button */}
          <Grid item xs={12} sm={1}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleReset}
              sx={{
                height: "35px",
                whiteSpace: "nowrap",
                borderRadius: "0",
                fontSize: "0.7rem",
              }}
              fullWidth
            >
              Reset
            </Button>
          </Grid>

          {/* ✅ Excel Export Button */}
          <Grid item xs={12} sm={1}>
            <Box
              display="flex"
              justifyContent={{ xs: "flex-end", sm: "center" }}
            >
              <IconButton
                color="success"
                size="small"
                onClick={handleExcelExport}
                disabled={excelLoading}
                sx={{
                  borderRadius: 0,
                  padding: "6px",
                }}
              >
                {excelLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <FileIcon fontSize="small" />
                )}
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Box>
      

      {/* ✅ CONDITIONAL RENDERING - Mobile vs Desktop */}
      {isMobile ? (
        <InfiniteScroll
          dataLength={proformas.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={
            <Typography
              sx={{
                textAlign: "center",
                py: 2,
                fontSize: "0.875rem",
                color: "#666",
              }}
            >
              Loading...
            </Typography>
          }
          endMessage={
            <Box sx={{ textAlign: "center", py: 4, pb: 4 }}>
              <Typography
                sx={{
                  textAlign: "center",
                  py: 3,
                  fontSize: "0.75rem",
                  color: "#999",
                  mb: 2,
                }}
              >
                No more records!
              </Typography>
            </Box>
          }
          // height="75vh"
          height="calc(100vh - 180px)" // ✅ Dynamic height
          style={{ overflow: "auto" }}
        >
          <Box sx={{ bgcolor: "background.paper", pb: 5 }}>
            {proformas.length > 0 ? (
              proformas.map((invoice, index) => (
                <Box
                  key={invoice.invoice_number}
                  sx={{
                    mb: index === proformas.length - 1 ? 4 : 0, // ✅ Last item margin
                  }}
                >
                  {/* Main Row */}
                  <Box
                    onClick={() =>
                      setExpandedInvoice(
                        expandedInvoice === invoice.invoice_number
                          ? null
                          : invoice.invoice_number,
                      )
                    }
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 1.5,
                      cursor: "pointer",
                      bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:active": {
                        bgcolor: "#e3f2fd",
                      },
                      borderLeft: "4px solid #1976d2",
                    }}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 0.5,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#666",
                            minWidth: 25,
                          }}
                        >
                          #{index + 1}
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "0.85rem",
                            flex: 1,
                          }}
                        >
                          {invoice.pi_no}
                        </Typography>

                        <Chip
                          label={
                            invoice.status === "Approved"
                              ? "Approved"
                              : invoice.status === "Rejected"
                                ? "Rejected"
                                : "Pending"
                          }
                          color={
                            invoice.status === "Approved"
                              ? "success"
                              : invoice.status === "Rejected"
                                ? "error"
                                : "warning"
                          }
                          variant="outlined"
                          size="small"
                          sx={{
                            fontSize: "0.6rem",
                            height: 20,
                          }}
                        />
                      </Box>

                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          color: "#666",
                        }}
                      >
                        Project:{" "}
                        {truncateText(invoice.project?.project_name || "-", 25)}
                      </Typography>
                    </Box>

                    <IconButton size="small" sx={{ ml: 1 }}>
                      {expandedInvoice === invoice.invoice_number ? (
                        <ExpandLess fontSize="small" />
                      ) : (
                        <ExpandMore fontSize="small" />
                      )}
                    </IconButton>
                  </Box>

                  {/* Expanded Details */}
                  <Collapse
                    in={expandedInvoice === invoice.invoice_number}
                    timeout="auto"
                    unmountOnExit
                  >
                    <Box
                      sx={{
                        px: 1.5,
                        py: 1,
                        bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                        borderLeft: "4px solid #1976d2",
                      }}
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: 0.8,
                          mb: 1,
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            PI AMOUNT
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            ₹{" "}
                            {Number(invoice.advance_received).toLocaleString(
                              "en-IN",
                              {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                              },
                            )}
                          </Typography>
                        </Box>

                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            REC AMOUNT
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            ₹{" "}
                            {Number(invoice.receive_amt).toLocaleString(
                              "en-IN",
                              {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                              },
                            )}
                          </Typography>
                        </Box>

                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            DIVISION
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {invoice.project?.division_name || "-"}
                          </Typography>
                        </Box>

                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            DATE
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {formatOnlyDate(invoice.created_at)}
                          </Typography>
                        </Box>
                      </Box>

                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          DEBTOR
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#555",
                            lineHeight: 1.3,
                            fontWeight: 500,
                          }}
                        >
                          {invoice.project.party_details?.company_name || "-"}
                        </Typography>
                      </Box>

                      {invoice.remarks && (
                        <Box sx={{ mb: 0.8 }}>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                              mb: 0.3,
                            }}
                          >
                            REMARKS
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              color: "#555",
                              lineHeight: 1.3,
                            }}
                          >
                            {invoice.remarks}
                          </Typography>
                        </Box>
                      )}

                      <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            fontWeight: 600,
                            letterSpacing: "0.5px",
                          }}
                        >
                          ACTIONS
                        </Typography>

                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            printPerforma(invoice);
                          }}
                          sx={{
                            bgcolor: "#e8f5e9",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#c8e6c9",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Print sx={{ fontSize: "1rem", color: "#2e7d32" }} />
                        </IconButton>
                      </Box>
                    </Box>
                  </Collapse>

                  <Divider />
                </Box>
              ))
            ) : (
              <Box sx={{ textAlign: "center", py: 4, color: "#999" }}>
                <Typography>No matching records found</Typography>
              </Box>
            )}
          </Box>
        </InfiniteScroll>
      ) : (
        // </Box>
        /* 💻 DESKTOP VIEW - YOUR ORIGINAL TABLE */
     <TableContainer
          component={Paper}
          id="scrollableTableDiv"
          sx={{
            maxHeight: "88vh",
            overflow: "auto",
          }}
        >
        <InfiniteScroll
          dataLength={proformas.length}
          next={fetchMoreData}
          hasMore={hasMore}
          height="88vh" // 👈 Give height directly to InfiniteScroll
          loader={
            <Typography sx={{ textAlign: "center", py: 2 }}>
              Loading more...
            </Typography>
          }
          endMessage={
            <Typography sx={{ textAlign: "center", py: 2 }}>
              No more records!
            </Typography>
          }
        >
      
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: "max-content",
                "& td, & th": {
                  borderBottom: "1px solid #ccc",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <TableHead
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  },
                }}
              >
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  <TableCell align="center">S.No.</TableCell>

                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      background: "#fff",
                      zIndex: 3,
                    }}
                    align="center"
                  >
                    PI No.
                  </TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Debtor</TableCell>
                  <TableCell align="center">Division</TableCell>
                  <TableCell align="center">PI Amt</TableCell>
                  <TableCell align="center">Rec Amt</TableCell>
                  <TableCell align="center">Project</TableCell>
                  <TableCell align="center">Date</TableCell>
                  <TableCell>Remarks</TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#fff",
                      zIndex: 3,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(proformas) &&
                  proformas.map((invoice, idx) => (
                    <TableRow
                      key={invoice.invoice_number}
                      hover
                      sx={{
                        backgroundColor: idx % 2 === 0 ? "#fafafa" : "#ffffff",
                        "&:hover": {
                          backgroundColor: "#e3f2fd !important",
                        },
                        "& td": {
                          paddingTop: "2px !important",
                          paddingBottom: "2px !important",
                          fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          color: (theme) =>
                            theme.palette.mode === "dark" ? "white" : "inherit",
                          backgroundColor: (theme) =>
                            theme.palette.mode === "dark" ? "black" : "inherit",
                        },
                      }}
                    >
                      <TableCell align="center">{idx + 1}</TableCell>

                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          background: "#f9f9f9",
                          zIndex: 1,
                        }}
                        align="center"
                      >
                        {invoice.pi_no}
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={
                            invoice.status === "Approved"
                              ? "Approved"
                              : invoice.status === "Rejected"
                                ? "Rejected"
                                : "Pending"
                          }
                          color={
                            invoice.status === "Approved"
                              ? "success"
                              : invoice.status === "Rejected"
                                ? "error"
                                : "warning"
                          }
                          variant="outlined"
                          size="small"
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip
                          title={
                            invoice.project.party_details?.company_name || "-"
                          }
                          arrow
                        >
                          <span>
                            {truncateText(
                              invoice.project.party_details?.company_name ||
                                "-",
                              20,
                            )}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center">
                        {invoice.project?.division_name || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {Number(invoice.advance_received).toLocaleString(
                          "en-IN",
                          {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                          },
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {Number(invoice.receive_amt).toLocaleString("en-IN", {
                          minimumFractionDigits: 1,
                          maximumFractionDigits: 1,
                        })}
                      </TableCell>

                      <TableCell align="center">
                        {invoice.project?.project_name || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {formatOnlyDate(invoice.created_at)}
                      </TableCell>
                      <TableCell>
                        <Tooltip title={invoice.remarks} arrow>
                          <span>{truncateText(invoice.remarks, 20)}</span>
                        </Tooltip>
                      </TableCell>
                      <TableCell
                        sx={{
                          position: "sticky",
                          right: 0,
                          backgroundColor: "#f9f9f9",
                          zIndex: 1,
                        }}
                        align="center"
                      >
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small"
                          onClick={() => printPerforma(invoice)}
                        >
                          <Print fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
        </InfiniteScroll>
          </TableContainer>
      )}
      </Box>

      <ToastContainer position="top-right" autoClose={3000} />
      <Popover
        open={Boolean(approveAnchorEl)}
        anchorEl={approveAnchorEl}
        onClose={() => {
          setApproveAnchorEl(null);
          setPIToApprove(null);
          setRemarkInput("");
          setShowRemarkForOrderId(null);
          setActionType(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2, minWidth: 250 }}>
          {/* Step 1: Reject clicked → show remark input */}
          {showRemarkForOrderId === piToApprove?.invoice_number ? (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Please enter remark before{" "}
                {actionType === "Approved" ? "approving" : "rejecting"}:
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={remarkInput}
                onChange={(e) => setRemarkInput(e.target.value)}
                placeholder="Enter remark"
              />

              {/* Yes/No buttons */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Button
                  color={actionType === "Approved" ? "success" : "error"}
                  size="small"
                  onClick={() => {
                    if (!remarkInput.trim()) {
                      toast.error("Remark is required!");
                      return;
                    }
                    // ✅ Reject with remark
                    handleApprove({
                      ...piToApprove,
                      status: actionType,
                      remarks: remarkInput,
                    });
                    setApproveAnchorEl(null);
                    setPIToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForOrderId(null);
                    setActionType(null);
                  }}
                >
                  Yes
                </Button>
                <Button
                  size="small"
                  onClick={() => {
                    setApproveAnchorEl(null);
                    setPIToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForOrderId(null);
                    setActionType(null);
                  }}
                >
                  No
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Do you want to approve or reject this Sales order?
              </Typography>

              {/* Approve/Reject buttons */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Button
                  color="success"
                  size="small"
                  onClick={() => {
                    setShowRemarkForOrderId(piToApprove?.invoice_number);
                    setActionType("Approved");
                  }}
                >
                  Approve
                </Button>
                <Button
                  color="error"
                  size="small"
                  onClick={() => {
                    // ✅ Switch to remark input mode
                    setShowRemarkForOrderId(piToApprove?.invoice_number);
                    setActionType("Rejected");
                  }}
                >
                  Reject
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Popover>
      {/* View Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>Proforma Invoice - {selectedInvoice?.ref_no}</DialogTitle>
        <DialogContent dividers>
          {selectedInvoice && (
            <Stack spacing={2}>
              <Typography>
                <strong>To:</strong> {selectedInvoice.to_name} (
                {selectedInvoice.to_company})
              </Typography>
              <Typography>
                <strong>Address:</strong> {selectedInvoice.to_address}
              </Typography>
              <Typography>
                <strong>Date:</strong> {selectedInvoice.date}
              </Typography>
              <Typography>
                <strong>Subject:</strong> {selectedInvoice.subject}
              </Typography>
              <Typography>{selectedInvoice.body}</Typography>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Sl. No.</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell align="right">Qty</TableCell>
                      <TableCell align="right">Rate</TableCell>
                      <TableCell align="right">Total</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedInvoice.items.map((item, i) => (
                      <TableRow key={i}>
                        <TableCell>{i + 1}</TableCell>
                        <TableCell>{item.description}</TableCell>
                        <TableCell align="right">{item.quantity}</TableCell>
                        <TableCell align="right">{item.unit_rate}</TableCell>
                        <TableCell align="right">{item.total}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Typography align="right">
                <strong>Total Amount:</strong> ₹ {selectedInvoice.total_amount}
              </Typography>
              <Typography>
                <strong>GST %:</strong> {selectedInvoice.gst_percent}
              </Typography>
              <Typography>
                <strong>Validity:</strong> {selectedInvoice.validity}
              </Typography>
              <Typography>
                <strong>Delivery:</strong> {selectedInvoice.delivery}
              </Typography>
              <Typography>
                <strong>Warranty:</strong> {selectedInvoice.warranty}
              </Typography>
              <Typography>
                <strong>Inspection Required:</strong>{" "}
                {selectedInvoice.inspection_required ? "Yes" : "No"}
              </Typography>
            </Stack>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setInvoiceToDelete(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box p={2}>
          <Typography>Are you sure you want to delete this invoice?</Typography>
          <Box display="flex" justifyContent="flex-end" gap={1} mt={1}>
            <Button
              color="error"
              onClick={() => {
                handleDelete(invoiceToDelete);
                setAnchorEl(null);
              }}
            >
              Yes
            </Button>
            <Button onClick={() => setAnchorEl(null)}>No</Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default ProformaInvoiceTable;
